export default "__VITE_ASSET__e83650c5__"